export enum CustomFieldKeyMode {
  SHOW,
  EDIT,
  DELETE,
}
